module.exports = __webpack_public_path__ + "img/ebpsn.90369cbf.png";